import { useCallback } from 'react';

import { ModalBody, ModalHeader } from 'apps/shared/scripts/components';

import SignupContainer from './SignupContainer';

interface Props {
  onBack: () => void;
  onCancel: () => void;
  onComplete: () => void;
  onLogin: () => void;
}

const SignupModalContainer = ({
  onBack,
  onCancel,
  onComplete,
  onLogin,
}: Props) => {
  const onSuccess = useCallback(() => {
    onComplete();
  }, [onComplete]);
  return (
    <>
      <ModalHeader onBack={onBack} onDismiss={onCancel} title={'Sign up'} />
      <ModalBody>
        <SignupContainer onLogin={onLogin} onSuccess={onSuccess} modal />
      </ModalBody>
    </>
  );
};

SignupModalContainer.displayName = 'SignupModalContainer';

export default SignupModalContainer;
